import { apiClient } from "@/lib/api-client";

export interface MasterPeriodeDetailResponse {
  datas: Array<{
    master_unsur_id: number;
    kode_unsur: string;
    nama_unsur: string;
    details: Array<{
      detail: {
        id: string;
        master_periode_detail_id: number;
        master_periode_id: number;
        kode_komponen: string;
        jml_maks_sks: number;
        bkd: number;
        point_tp: number;
        point_aa: number;
        point_l: number;
        point_lk: number;
        point_gb: number;
        created_at: string;
        updated_at: string | null;
        deleted_at: string | null;
      };
      komponen: {
        master_komponen_kegiatan_id: number;
        kode_komponen: string;
        komponen_kegiatan: string;
        master_unsur_id: number;
        kode_alternatif: string;
        satuan: string;
        sumber_data: string;
        is_active_banding: number;
        keterangan_komponen: string;
        created_at: string;
        updated_at: string | null;
        deleted_at: string | null;
      };
    }>;
  }>;
}

export const fetchMasterPeriodeDetail = async (periodeId: string | number) => {
  if (!periodeId) return null;
  const res = await apiClient<MasterPeriodeDetailResponse>(
    `/api/v1/master-periode-detail/${periodeId}`,
  );
  return res;
};
